export default __webpack_public_path__ + "static/media/WorkStation3.ee81eb39.jpg";